import { render, staticRenderFns } from "./TextInputModal.vue?vue&type=template&id=4132b561&scoped=true&"
import script from "./TextInputModal.vue?vue&type=script&lang=ts&"
export * from "./TextInputModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4132b561",
  null
  
)

export default component.exports